import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Toaster } from "sonner";
import Logo from "../../components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@hearclear.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("hc_admin_token", data.access_token);
      localStorage.setItem("hc_admin_user", JSON.stringify(data.admin));
      toast.success("Welcome back");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] p-4">
      <Toaster richColors position="top-center" />
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-3xl p-8 shadow-md">
        <Link to="/" className="mb-6 inline-block">
          <Logo variant="full" tone="dark" size={44} />
        </Link>
        <h1 className="font-serif text-2xl font-semibold text-slate-900">Admin sign in</h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-6 space-y-4">
          <div>
            <label className="label-hc">Email</label>
            <input data-testid="admin-email" required type="email" className="input-hc" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label-hc">Password</label>
            <input data-testid="admin-password" required type="password" className="input-hc" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button data-testid="admin-submit" disabled={loading} className="btn-primary w-full">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
